import type { SqlDriver, SqlResult, StorageMode } from './driver';
import { createRpc } from './rpc';

/** One database file per account, so two accounts on one phone never mix. */
export function dbFileFor(userId: string): string {
  return `/tahi-${userId.replace(/[^A-Za-z0-9_-]/g, '_')}.sqlite3`;
}

export async function openWorkerDriver(userId: string): Promise<SqlDriver> {
  const worker = new Worker(new URL('./db.worker.ts', import.meta.url), {
    type: 'module',
    name: 'tahi-db',
  });
  const rpc = createRpc(worker);
  const { mode } = await rpc.call<{ mode: StorageMode }>({ type: 'open', file: dbFileFor(userId) });
  return {
    mode,
    query: (query) => rpc.call<SqlResult>({ type: 'query', query }),
    batch: (queries) => rpc.call<SqlResult[]>({ type: 'batch', queries }),
    async close() {
      await rpc.call({ type: 'close' });
      worker.terminate();
    },
    async wipe() {
      await rpc.call({ type: 'wipe' });
      worker.terminate();
    },
  };
}
